// libraries.
import { Navbar, Container, Row } from 'react-bootstrap';
import { monserratSemiBold } from '@habitech/shared';

// components.
import { SidebarOrchestrator } from '@pages/OrchestratorPricingCommitteePage/shared/SidebarOrchestrator/SidebarOrchestrator';
import {
  OrchestratorGeneralInfo,
  OrchestratorStep,
  SearchOrchestratorPricingCommittee,
  GoToListOrchestrator,
  InProgressStepsCardsByNid,
  AliasFilterDropdown,
} from '@domains/orchestrator-pricing-committee';
import { Layout } from '@shared';
import { OrchestratorLayout } from './styles';

export const Sales = () => {
  return (
    <Layout>
      <SidebarOrchestrator />
      <Container fluid className="w-100">
        <Navbar>
          <Container fluid className="p-0">
            <div
              className="d-flex align-items-center gap-2"
              style={{ fontFamily: monserratSemiBold, fontSize: '20px' }}
            >
              <GoToListOrchestrator />
              <span>Tracker Comercial</span>
            </div>
            <div className="d-flex justify-content-end gap-2">
              <AliasFilterDropdown />
              <SearchOrchestratorPricingCommittee />
            </div>
          </Container>
        </Navbar>
        <Row className="my-3" style={{ height: 'calc(100% - 74px)' }}>
          <OrchestratorLayout>
            <div className="general-info">
              <OrchestratorGeneralInfo />
            </div>
            <div className="step">
              <OrchestratorStep />
            </div>
            <InProgressStepsCardsByNid />
          </OrchestratorLayout>
        </Row>
      </Container>
    </Layout>
  );
};
